import { COMPARISON_LABELS } from '../lib/labels'

const MATRIX: Array<{ row: string; cycloud: string; aws: string; azure: string }> = [
  {
    row: 'Operator accountability',
    cycloud: 'Single operator — CyLogic builds, operates, monitors the entire stack',
    aws: 'Customer assembles services; AWS support routes by component',
    azure: 'Customer assembles services; Microsoft support routes by component',
  },
  {
    row: 'VMware-native compute',
    cycloud: 'VCF 5 + VCD and VCF 9 native',
    aws: 'VMC on AWS (separate service, premium)',
    azure: 'AVS (separate service, premium)',
  },
  {
    row: 'Hardware platform visibility',
    cycloud: 'Dell PowerEdge R670 / R770, Xeon 6 Granite Rapids, vSAN ESA',
    aws: 'AWS-managed, no customer visibility',
    azure: 'Microsoft-managed, no customer visibility',
  },
  {
    row: 'FedRAMP High boundary status',
    cycloud: 'Designed for inheritance, pursuing Authorization',
    aws: 'Customer must build own',
    azure: 'Customer must build own',
  },
  {
    row: 'Per-node sizing transparency',
    cycloud: 'Published per-node specs and bands',
    aws: 'Instance-family abstraction',
    azure: 'Instance-family abstraction',
  },
  {
    row: 'Contract-priced burst capacity',
    cycloud: 'Pre-priced, contracted',
    aws: 'On-demand rates, billed monthly',
    azure: 'On-demand rates, billed monthly',
  },
  {
    row: 'Egress fees on production traffic',
    cycloud: 'Zero — included',
    aws: '$92/TB to internet',
    azure: '$92/TB equivalent',
  },
  {
    row: 'Single-vendor accountability',
    cycloud: 'One contract, one escalation path',
    aws: 'Multi-vendor support chain',
    azure: 'Multi-vendor support chain',
  },
]

export function Compare() {
  return (
    <section id="compare" className="bg-chalk py-20 lg:py-24 scroll-mt-16">
      <div className="mx-auto max-w-7xl px-6">
        <header className="max-w-3xl mb-10">
          <h2 className="text-3xl sm:text-4xl font-semibold text-navy tracking-tight">
            How CyLogic-operated CyCloud compares to federal alternatives.
          </h2>
          <p className="mt-3 text-base text-navy/70">
            Capability matrix — what CyLogic operates vs. what the customer assembles,
            builds, or buys piecemeal. TCO comparison and methodology live in the sizer
            above.
          </p>
        </header>

        <div className="bg-white border border-mist rounded-card shadow-card overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-navy text-white">
                  <th className="text-left px-5 py-4 font-medium">Capability</th>
                  <th className="text-left px-5 py-4 font-medium">
                    <span className="text-mint">{COMPARISON_LABELS.cyCloud}</span>
                  </th>
                  <th className="text-left px-5 py-4 font-medium font-data text-xs uppercase tracking-wide">
                    {COMPARISON_LABELS.awsGovCloud}
                  </th>
                  <th className="text-left px-5 py-4 font-medium font-data text-xs uppercase tracking-wide">
                    {COMPARISON_LABELS.azureGov}
                  </th>
                </tr>
              </thead>
              <tbody>
                {MATRIX.map((m, i) => (
                  <tr
                    key={m.row}
                    className={i % 2 === 0 ? 'bg-white' : 'bg-chalk/40'}
                  >
                    <td className="px-5 py-4 font-medium text-navy align-top">{m.row}</td>
                    <td className="px-5 py-4 text-navy align-top bg-foam/30">
                      <span className="font-medium">{m.cycloud}</span>
                    </td>
                    <td className="px-5 py-4 text-navy/70 align-top">{m.aws}</td>
                    <td className="px-5 py-4 text-navy/70 align-top">{m.azure}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <p className="mt-5 text-xs text-navy/55 font-data">
          Comparison reflects published federal-tier rates for AWS GovCloud and Azure
          Government. Methodology details are surfaced inline in the sizer's "How we get to
          this number" panel above.
        </p>
      </div>
    </section>
  )
}
